module.exports = __webpack_public_path__ + "img/symbol_11.f8b4f4c8.png";